import React from "react";
import {
  Input,
  FormGroup,
  Label,
  FormFeedback,
  InputGroup,
  InputGroupAddon,
  InputGroupText
} from "reactstrap";
import { MdRotateRight } from "react-icons/md";
export default props => {
  const { input, label, id, meta: { error, touched }, reload, image, loading, ...rest } = props;
  return (
    <FormGroup onClick={() => { props.input.onFocus() }}>
      {label && <Label htmlFor={id}>{label}</Label>}
      <InputGroup dir="ltr">
        <InputGroupAddon
          className="input-group-addon"
          addonType="prepend"
        >
          <InputGroupText style={{ width: 130 }}>
            <MdRotateRight
              style={{ height: 24, cursor: 'pointer' }}
              onClick={() => reload()}
            />
            {image && (
              <img height="24" src={image} alt="" />
            )}
          </InputGroupText>
        </InputGroupAddon>
        <Input id={id} invalid={error && touched} disabled={loading || input.disabled} {...input} {...rest} />
        {error && touched && <FormFeedback>{error}</FormFeedback>}
      </InputGroup>
    </FormGroup>
  )
}